import { Button, Modal, Spinner } from "react-bootstrap";
import React, { useState, useCallback, useEffect } from "react";
import { CALL_IMAGE } from "../../../../context/constValues";

// Estructura inicial de los accesos
const ACCESOS_INICIALES = {
  Ventas: {
    Clientes: false,
    Facturas: false,
    FichaFactura: false,
    Detalles: false,
    Reportes: false,
    FacturasContado: false,
    FacturasCredito: false,
    Montos: false,
  },
  Compras: {
    Proveedores: false,
    Compras: false,
    ListaCompras: false,
    Reportes: false,
  },
  Opciones: {
    Timbrado: false,
    Sucursal: false,
    PuntosDeVenta: false,
    FormasDePago: false,
    ServicioProducto: false,
    Seguros: false,
  },
};

// Fallback seguro para campos de accesos faltantes
function safeItemAccesos(item = {}) {
  return {
    ventas_clientes:           item.ventas_clientes ?? false,
    ventas_facturas:           item.ventas_facturas ?? false,
    ventas_fichafactura:       item.ventas_fichafactura ?? false,
    ventas_detalles:           item.ventas_detalles ?? false,
    ventas_reportes:           item.ventas_reportes ?? false,
    ventas_facturascontado:    item.ventas_facturascontado ?? false,
    ventas_facturascredito:    item.ventas_facturascredito ?? false,
    ventas_montos:             item.ventas_montos ?? false,
    compras_proveedores:       item.compras_proveedores ?? false,
    compras_compras:           item.compras_compras ?? false,
    compras_listacompras:      item.compras_listacompras ?? false,
    compras_reportes:          item.compras_reportes ?? false,
    opciones_timbrado:         item.opciones_timbrado ?? false,
    opciones_sucursal:         item.opciones_sucursal ?? false,
    opciones_puntosdeventa:    item.opciones_puntosdeventa ?? false,
    opciones_formasdepago:     item.opciones_formasdepago ?? false,
    opciones_servicioproducto: item.opciones_servicioproducto ?? false,
    opciones_seguros:          item.opciones_seguros ?? false,
  };
}

// Convierte objeto plano (string "true"/"false", boolean, 0/1) a estructura anidada booleana
function normalizarAccesosStringsToBooleans(datos = {}) {
  const toBool = (v) => v === "true" || v === true || v === 1 || v === "1";
  return {
    Ventas: {
      Clientes:        toBool(datos.ventas_clientes),
      Facturas:        toBool(datos.ventas_facturas),
      FichaFactura:    toBool(datos.ventas_fichafactura),
      Detalles:        toBool(datos.ventas_detalles),
      Reportes:        toBool(datos.ventas_reportes),
      FacturasContado: toBool(datos.ventas_facturascontado),
      FacturasCredito: toBool(datos.ventas_facturascredito),
      Montos:          toBool(datos.ventas_montos),
    },
    Compras: {
      Proveedores:  toBool(datos.compras_proveedores),
      Compras:      toBool(datos.compras_compras),
      ListaCompras: toBool(datos.compras_listacompras),
      Reportes:     toBool(datos.compras_reportes),
    },
    Opciones: {
      Timbrado:         toBool(datos.opciones_timbrado),
      Sucursal:         toBool(datos.opciones_sucursal),
      PuntosDeVenta:    toBool(datos.opciones_puntosdeventa),
      FormasDePago:     toBool(datos.opciones_formasdepago),
      ServicioProducto: toBool(datos.opciones_servicioproducto),
      Seguros:          toBool(datos.opciones_seguros),
    },
  };
}

const ModalCuentaAdmin = (props) => {
  const { estado, onCloseModal, item = {}, onReturnValue, isnew } = props;
  const maxFileSize = 5 * 1024 * 1024; // 5 MB

  const [fotoPreview, setFotoPreview] = useState();
  const [fotodefault, setDefault] = useState();
  const [formData, setFormData] = useState({
    idadmin:   item.idadmin || "",
    cuenta:    item.cuenta || "",
    contraseña: "",
    nombre:    item.nombrecompleto || "",
    cedula:    item.cedula || "",
    foto:      item.foto || null,
    accesos:   isnew ? ACCESOS_INICIALES : normalizarAccesosStringsToBooleans(safeItemAccesos(item)),
  });

  const [errorFoto, setErrorFoto] = useState("");
  const [isLoadingFoto, setIsLoadingFoto] = useState(false);

  const assigmentValueAdmin = useCallback(async () => {
    setIsLoadingFoto(true);
    try {
      if (item.foto && !isnew) {
        const res = await fetch(`${CALL_IMAGE}${item.foto}`);
        if (res.ok) {
          const imageBlob = await res.blob();
          setFotoPreview(URL.createObjectURL(imageBlob));
        }
      }
      const res2 = await fetch(`${CALL_IMAGE}images/defaultimg.png`);
      if (res2.ok) {
        const imageBlob2 = await res2.blob();
        const url2 = URL.createObjectURL(imageBlob2);
        setDefault(url2);
        if (!item.foto || isnew) setFotoPreview(url2);
      }
    } catch (error) {
      setErrorFoto("Error al cargar la imagen.");
    } finally {
      setIsLoadingFoto(false);
    }
  }, [item.foto, isnew]);

  useEffect(() => {
    assigmentValueAdmin();
  }, [assigmentValueAdmin]);

  useEffect(() => {
    if (!isnew && item) {
      const accesosCompletos = safeItemAccesos(item);
      setFormData((prev) => ({
        ...prev,
        accesos: normalizarAccesosStringsToBooleans(accesosCompletos),
        idadmin: item.idadmin || "",
      }));
    }
  }, [item, isnew]);

  const handleFotoChange = (event) => {
    const file = event.target.files[0];
    setErrorFoto("");
    if (file) {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        setErrorFoto("Solo se permiten archivos PNG, JPG o JPEG.");
        setFormData({ ...formData, foto: item.foto || null });
        setFotoPreview(fotodefault);
        event.target.value = "";
        return;
      }
      if (file.size > maxFileSize) {
        setErrorFoto("La imagen no debe exceder los 5 MB.");
        setFormData({ ...formData, foto: item.foto || null });
        setFotoPreview(fotodefault);
        event.target.value = "";
        return;
      }
      setIsLoadingFoto(true);
      setFormData({ ...formData, foto: file });
      const reader = new FileReader();
      reader.onload = (e) => {
        setFotoPreview(e.target.result);
        setIsLoadingFoto(false);
      };
      reader.onerror = () => {
        setErrorFoto("Error al cargar la imagen.");
        setIsLoadingFoto(false);
      };
      reader.readAsDataURL(file);
    } else {
      setFormData({ ...formData, foto: item.foto || null });
      setFotoPreview(item.foto && !isnew ? `${CALL_IMAGE}${item.foto}` : fotodefault);
    }
  };

  const handleAccesoChange = (grupo, subacceso) => {
    setFormData((prev) => ({
      ...prev,
      accesos: {
        ...prev.accesos,
        [grupo]: {
          ...prev.accesos[grupo],
          [subacceso]: !prev.accesos[grupo][subacceso],
        },
      },
    }));
  };

  // ✅ FIX PRINCIPAL: se pasa el estado React directamente.
  // insertAdmin / updateAdmin en AdminApi.js construyen el FormData
  // con ORDEN_ACCESOS garantizado antes de enviarlo al backend.
  // El formDataEnviar que se creaba aquí se descartaba sin usarse.
  const handleSubmit = (event) => {
    event.preventDefault();
    if (errorFoto || isLoadingFoto) return;
    onReturnValue(formData, isnew, "ADMIN");
  };

  return (
    <Modal show={estado} onHide={onCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Registro de Cuenta Administrativa</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} id="auFORM">

          {/* Foto */}
          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Foto
              <input
                type="file"
                className="form-control"
                accept="image/png,image/jpeg,image/jpg"
                onChange={handleFotoChange}
                disabled={isLoadingFoto}
              />
              {errorFoto && <div className="text-danger mt-1">{errorFoto}</div>}
            </label>
            <div className="mt-2 text-center" style={{ minHeight: "150px" }}>
              {isLoadingFoto ? (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </Spinner>
              ) : (
                <img
                  src={fotoPreview || fotodefault}
                  alt="Vista previa"
                  style={{ maxWidth: "150px", maxHeight: "150px", objectFit: "cover", borderRadius: "50%" }}
                />
              )}
            </div>
          </div>

          {/* Cuenta */}
          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Cuenta <span className="text-danger">*</span>
              <input
                className="form-control"
                required
                value={formData.cuenta}
                onChange={(e) => setFormData({ ...formData, cuenta: e.target.value })}
              />
            </label>
          </div>

          {/* Contraseña — solo al crear */}
          {isnew && (
            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Contraseña <span className="text-danger">*</span>
                <input
                  type="password"
                  className="form-control"
                  required
                  value={formData.contraseña}
                  onChange={(e) => setFormData({ ...formData, contraseña: e.target.value })}
                />
              </label>
            </div>
          )}

          {/* Nombre completo */}
          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Nombre completo <span className="text-danger">*</span>
              <input
                type="text"
                className="form-control"
                required
                value={formData.nombre}
                onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
              />
            </label>
          </div>

          {/* Cédula */}
          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Cédula <span className="text-danger">*</span>
              <input
                type="text"
                className="form-control"
                required
                value={formData.cedula}
                onChange={(e) => setFormData({ ...formData, cedula: e.target.value })}
              />
            </label>
          </div>

          {/* Accesos */}
          <div className="form-group mb-2">
            <label className="col-form-label">Accesos</label>
            {Object.keys(ACCESOS_INICIALES).map((grupo) => (
              <div key={grupo} className="mb-2">
                <strong>{grupo}</strong>
                <div className="row">
                  {Object.keys(ACCESOS_INICIALES[grupo]).map((subacceso) => (
                    <div className="col-6" key={subacceso}>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={formData.accesos[grupo][subacceso]}
                          onChange={() => handleAccesoChange(grupo, subacceso)}
                          id={`${grupo}-${subacceso}`}
                        />
                        <label className="form-check-label" htmlFor={`${grupo}-${subacceso}`}>
                          {subacceso.replace(/([A-Z])/g, " $1").trim()}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cerrar
        </Button>
        <Button type="submit" form="auFORM" disabled={isLoadingFoto}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCuentaAdmin;